export default __webpack_public_path__ + "static/media/bg.b1a597c1.webp";